<template>
    <Input :placeholder="defaultAccountName" id="accountName" classes="col-12" :label="$t('Account name')"
        name="accountName" rules="required" :value="product.attributes.accountName"
        @updated-value="updatedInputField" />
    <Input :placeholder="defaultDescription" id="description" classes="col-12" :label="$t('Description')"
        name="description" rules="required" :value="product.attributes.description"
        @updated-value="updatedInputField" />
    <Input :placeholder="$t('Like it')" id="like" classes="col-12" :label="$t('Like it')" name="like" rules="required"
        :value="product.attributes.like" @updated-value="updatedInputField" />
    <Input :placeholder="$t('and others')" id="others" classes="col-12" :label="$t('And others')" name="others"
        rules="required" :value="product.attributes.others" @updated-value="updatedInputField" />
    <div class="form-group col-12 radio-container">
        <input type="checkbox" name="approvedAccountRadio" id="approvedAccountRadio"
            v-model="product.attributes.approvedAccount" @change="toggleCheckbox($event, 'approvedAccount')" />
        <div class="text">
            <label for="approvedAccountRadio">{{  $t('Approved account')  }}</label>
            <img src="/img/product/insta/approved.png" alt="Overené ikonka"/>
        </div>
    </div>
    <div class="form-group col-12 radio-container">
        <input type="checkbox" name="likedPhotoRadio" id="likedPhotoRadio" v-model="product.attributes.likedPhoto"
            @change="toggleCheckbox($event, 'likedPhoto')" />
        <div class="text">
            <label for="likedPhotoRadio">{{  $t('Liked photo')  }}</label>
            <img src="/img/product/insta/heart_liked.png" alt="Páči sa ikonka"/>
        </div>
    </div>
    <div class="form-group col-12 radio-container">
        <input type="checkbox" name="activeStoriesRadio" id="activeStoriesRadio"
            v-model="product.attributes.activeStories" @change="toggleCheckbox($event, 'activeStories')" />
        <div class="text">
            <label for="activeStoriesRadio">{{  $t('Active stories')  }}</label>
            <img src="/img/product/insta/active_story.png" alt="Aktívna story ikonka"/>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import useProduct from "../../useProduct";
import useInsta from "../../useInsta";
import Input from "../Input.vue";

export default {
    components: {
        Input
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct'
        })
    },
    setup() {
        const {
            updatedInputField,
            toggleHideCheckbox,
            toggleCheckbox
        } = useProduct()
        const {
            defaultAccountName,
            defaultDescription,
        } = useInsta()

        return {
            updatedInputField,
            toggleHideCheckbox,
            toggleCheckbox,
            defaultAccountName,
            defaultDescription,
        }
    }
}
</script>